var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01.facebook",
    "data-name": "01.facebook"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "background",
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#334c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M67.927,46.959l-.366,3.077a.582.582,0,0,1-.582.518h-3.2v9.131a.413.413,0,0,1-.407.416h-3.26a.413.413,0,0,1-.407-.419l.017-9.128H57.3a.582.582,0,0,1-.582-.582V46.9a.582.582,0,0,1,.582-.582h2.408V43.33c0-3.452,2.053-5.33,5.06-5.33h2.463a.582.582,0,0,1,.582.582v2.591a.582.582,0,0,1-.582.582H65.723c-1.634.026-1.942.808-1.942,1.977V46.3h3.58a.582.582,0,0,1,.567.654Z",
    transform: "translate(-40.226 -26.95)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9e4c0163ee8e87fac4f935398698ee8f.svg";
export { ForwardRef as ReactComponent };